export default __webpack_public_path__ + "static/media/Principal-Logo-2.8ee452af.svg";